import React from "react";
import Chat from "./Chat";
import './App.css'

function App() {
  return <Chat />;
}

export default App;